import { render, staticRenderFns } from "./Empty3.vue?vue&type=template&id=993215cc&scoped=true"
import script from "./Empty3.vue?vue&type=script&lang=js"
export * from "./Empty3.vue?vue&type=script&lang=js"
import style0 from "./Empty3.vue?vue&type=style&index=0&id=993215cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993215cc",
  null
  
)

export default component.exports